import { render, staticRenderFns } from "./SurplusForm.vue?vue&type=template&id=dde00f5c&scoped=true&"
import script from "./SurplusForm.vue?vue&type=script&lang=js&"
export * from "./SurplusForm.vue?vue&type=script&lang=js&"
import style0 from "./SurplusForm.vue?vue&type=style&index=0&id=dde00f5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde00f5c",
  null
  
)

export default component.exports